import { render, staticRenderFns } from "./GeneralManagement.vue?vue&type=template&id=7ebfa692"
import script from "./GeneralManagement.vue?vue&type=script&lang=js"
export * from "./GeneralManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports